import React, {Fragment} from "react";
import logo from "../../../../assets/logos/hot-new.svg";
import "./index.scss";
import {useSelector} from "react-redux";
import {getMediaPath} from "../../../../app/functions";
import {NavLink} from "react-router-dom";
import * as Routes from "../../../../constants/routes";

const WhyPurchase = (props) => {

    const vehicleAdsPage = useSelector(state => state.data.VehicleAdsPage);
    const deviceState = useSelector(state => state.state.deviceState);

    const getValues = () =>{
        let res = [];

        vehicleAdsPage.landing_page.why_us_arr.forEach((item, index) =>{
                res.push(
                    <div key={index} className='val-wrapper'>
                        <img src={getMediaPath(item.imagePath)} alt=''/>
                        <span className='val-title'>{item.title}</span>
                        <div className='text'>{item.text}</div>
                    </div>
                );
            });
        return res;
    };

    function displayImage(){
        if(deviceState === "mobile" ){
            return getMediaPath(vehicleAdsPage.landing_page.mobileImagePath);
        }
        return getMediaPath(vehicleAdsPage.landing_page.imagePath);
    }

    const scrollToBottom = () => {
        let componentBottom = document.getElementById("componentBottom")
        componentBottom.scrollIntoView({ behavior: "smooth" });
    }

    const openHotHomePage = () => {
        window.open(Routes.home, "_blank");
    }

    return(
        <div className="why-purchase">
            <Fragment>
                <div className='top'>
                    <img className='top-background' src={displayImage()} alt=''/>
                    <img className='logo' src={logo} alt='' onClick={openHotHomePage}/>
                    <div className='overly'>
                        <h2 className='top-title'>{vehicleAdsPage.landing_page.header}</h2>
                        <h2 className='top-subtitle'>{vehicleAdsPage.landing_page.sub_header}</h2>
                        <button className='find-car-btn' onClick={scrollToBottom}>{vehicleAdsPage.landing_page.btn_text}</button>
                    </div>
                </div>
                <div className='values'>
                    <div className='values-text-wrapper'>
                        <span className='values-title'>{vehicleAdsPage.landing_page.why_us_bold_header}</span>
                        <span className='values-title bold'>{vehicleAdsPage.landing_page.why_us_header}</span>
                    </div>
                    <div className='values-container'>
                        {getValues()}
                    </div>
                </div>

                <div id="componentBottom"></div>
            </Fragment>
        </div>
    );

}

export default WhyPurchase;